import { render, staticRenderFns } from "./WebsiteRenderer.vue?vue&type=template&id=39777c2a&scoped=true&"
import script from "./WebsiteRenderer.vue?vue&type=script&lang=js&"
export * from "./WebsiteRenderer.vue?vue&type=script&lang=js&"
import style0 from "./WebsiteRenderer.vue?vue&type=style&index=0&id=39777c2a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39777c2a",
  null
  
)

export default component.exports